// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__R7mLA","expireSoon":"styles_expireSoon__QoUgL"};